import React from 'react'
import {StaticQuery, graphql} from 'gatsby'
import Img from 'gatsby-image'

const ImageBarFull = () => (
    <StaticQuery
    query={graphql`
        {
            background: imageSharp(original: {src: {regex: "/aaron-burden-dXYE1d08BiY-unsplash/"}}) {
                fluid(maxWidth: 1920, maxHeight: 950, cropFocus: CENTER) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    `}
    render={ data => (
        <Img fluid={data.background.fluid} alt="" className="imageBar imageBar-full" />
    )}
    />
)

export default ImageBarFull